import { JOB_TYPES } from "@/lib/usg-constants";

interface JobTypeChipProps {
  type: string;
}

export function JobTypeChip({ type }: JobTypeChipProps) {
  const label = JOB_TYPES[type] ?? type;
  return (
    <span className={`chip-jobtype chip-jobtype--${type}`} title={label}>
      {type}
    </span>
  );
}
